export const SET_RECIPES = "setRecipes";
export const EDIT_RECIPE = "editRecipe";
export const ADD_RECIPE = "editRecipe";
export const COPY_RECIPE = "copyRecipe";
export const DELETE_RECIPE = "deleteRecipe";
